import { Component, Input, OnInit, HostBinding } from '@angular/core';
import { Store } from 'src/app/store';
import { environment } from 'src/environments/environment';
import { IChatMember, IChatMessage } from '../../models';

@Component({
    selector: 'app-chat-modal-message',
    templateUrl: './chat-modal-message.component.html',
    styleUrls: ['./chat-modal-message.component.scss'],
})
export class ChatModalMessageComponent implements OnInit {
    @Input() message: IChatMessage;

    @HostBinding(`class.right-align`)
    isRight: boolean = false;

    constructor(private store: Store) {}

    ngOnInit(): void {
        const user = this.store.selectForLocal('user');
        this.isRight = this.message?.user?.id !== user.id;
    }

    getPathToFile(src: string): string {
        return `${environment.imageUploadPath}${src}`;
    }
}
